import $ from 'jquery';
import BaseView from '@/base/module/base';
import PageView from '@/components/player/doc/view';
import ObserverPage from '@/base/module/observer/observer-page';
import Pager from '@/components/pager';
import Zoom from '@/components/zoom';
import { sendMessage } from '@/lib/message';
import { throttle, queryToJson } from '@/lib/tools';
import { getPreviewUrl } from '@/lib/resource';
import { getWinWH } from '@/components/player/media';

/**
 * 更新页码
 */
function updatePager(current) {
    this.current = current;
    this.pager.update(current).show();

    if (this.pagerTimer) {
        clearTimeout(this.pagerTimer);
    }
    this.pagerTimer = setTimeout(() => {
        this.pager.hide();
    }, 3 * 1000);
}

/**
 * 初始化加载文档前 10 页 
 * @param { Number } index 当前页码
 * @param { needGenPlaceholder } Boolean 是否需要构建出页面占位，初始化加载非第一页的时候需要, 
        true: 需要, false: 不需要
 * @param { size } Number 懒加载的页数, 默认为 3 页
 */
function loadPages(index = 1, needGenPlaceholder = false, size = 3) {
    let { url, ext, pageCount } = this.pageData;
    let i = needGenPlaceholder ? 1 : index;
    let num = index + size;
    if(num > pageCount) {
        num = pageCount;
    }
    if(!index) {
        return;
    }
    let currentView;
    let scrollTop = 0;
    for (i; i <= num; i++) { 
        console.log('i = ', i)
        let lazy = i >= index;
        let item = this.addItem({
            'index': i,
            'src': url + `-${i - 1}.${ext || 'jpg'}`,
            '$parent': this.$el,
            'lazy': lazy // true 默认加载页面内容; false 只做页面占位不加载展示内容
        });
        if(i === index && needGenPlaceholder) {
            item.scrollIntoView();
        }
    }
    this.loadedPageNum = num;
}

class DocPlayer extends BaseView {
    constructor(el, options) {
        super(el, options);
        this.list = [];
       
        this.pageData = {}; // 预览文档数据
        this.pagerTimer = null; // 页码timer
        this.loadedPageNum = 0; // 已加载的页数
        this.current = 1; // 当前页
        this.loadedStep = 3; // 缓存页码步长
        this.criticalPage = 3; // 页码加载的临界点，即销毁之前的dom元素
        this.initComponents();
        this.bindEvents();
        this.getData();
        this.pagesHeight = {};
    }

    initComponents() {
        this.observer = new ObserverPage(this.$el[0]);
    }

    bindEvents() {
        this.observer.addEventListener('pageChange', evt => {
            let { page } = evt;

            if(page * 1) {
                this.current = page;
                const currentPageView = this.list[page - 1]
                // 当前页往后3页大于已加载的页数，则向下缓存，initialize
                if(page + this.loadedStep > this.loadedPageNum && this.loadedPageNum < this.pageData.pageCount) {
                    if (currentPageView.removeMark) {
                        currentPageView.addImg()
                    } else {
                        loadPages.call(this, this.loadedPageNum + 1);
                    }
                }

                // 当前页大于this.criticalPage时，清空list数组下标this.current - this.criticalPage - 1的图片dom元素
                if (page > this.criticalPage) {
                    const pageViewItem = this.list[this.current - this.criticalPage - 1]
                    if (!pageViewItem.removeMark) {
                        pageViewItem.removeImg()
                    }
                }

                // 向上加载图片
                //TODO 滚动条向上时 当前页的removeMake为true时，则添加图片，同时需要将之前已经缓存的图片remove
                if (page == currentPageView.options.index && currentPageView.removeMark) {
                    currentPageView.addImg()
                    if (this.loadedPageNum - page > this.criticalPage) {
                        this.list.forEach((item, index) => {
                            if (page + this.loadedStep < index + 1) {
                                if (!item.removeMark) {
                                    item.removeImg()
                                }
                            }
                        })
                    }
                }

                updatePager.call(this, page);

                let index = page;
                if(index <= this.list.length) {
                    let view = this.list[index - 1].load();
                }
            }
        });
        this.observer.addEventListener('pageScroll', evt => {
            let h = 10;
            let index = 0;
            let client = getWinWH();
            let rectHeight = evt.offsetTop + client.clientHeight;
            for(let k in this.pagesHeight) {
                index++;
                h += this.pagesHeight[k] + 20; // +margin
                if(h >= rectHeight) {
                    updatePager.call(this, index);
                    break;
                }
            }
        });
    }

    getData() {
        getPreviewUrl().then(res => {
            let index = res.pageIndex;
            this.pageData = res;
            this.current = index;
            // 分页器
            this.pager = new Pager({
                current: index,
                total: Number(res.pageCount) || 0
            }).show();

            loadPages.call(this, index, index > 1);
        }).catch(err => {
            console.log(err)
        });
    }

    addItem(data, index) {
        let view = new PageView(data, this.observer);
        view.addEventListener('loaded', evt => {
            this.collectPageHeight(evt.getMetadata());
        });
        this.pushToViewList(view);
        return view;
    }

    pushToViewList(view) {
        this.collectPageHeight(view.getMetadata());
        this.list.push(view);
        this.observer.observe(view.getElement());
    }

    collectPageHeight(metadata) {
        this.pagesHeight[metadata.index] = metadata.height;
    }

    getPageHeight() {
        let h = 0;
        for(let k in this.pagesHeight) {
            h += this.pagesHeight[k] + 20; // +margin
        }
        return h + 10 + 30; // +margin
    }
}

export default DocPlayer;